export abstract class ApplicationBase {
  name = "";
  
}
